var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoreVertIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    viewBox: "0 0 426.667 426.667",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 42.667,
    cy: 213.333,
    r: 42.667,
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.333,
    cy: 213.333,
    r: 42.667,
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384,
    cy: 213.333,
    r: 42.667,
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreVertIcon);
export default __webpack_public_path__ + "static/media/MoreVertIcon.e6c5f2ec013fbfd7d10c2dd3479f8ff0.svg";
export { ForwardRef as ReactComponent };